import GlobalRouterWrapper from "./middlewares/GlobalRouterWrapper";

const exports = {
    wrappers: [GlobalRouterWrapper],
}
export default exports;